<template>
    <div class="form-box clearfix">
        <el-form label-position="top" label-width="80px" :model="form" :rules="rules" ref="form">
            <el-form-item label="发票抬头" prop="invoiceName" :error="invoiceNameErrorMsg">
                <el-input v-model="form.invoiceName" type="text" maxlength="100" clearable></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="taxesNo" :error="taxesNoErrorMsg">
                <el-input v-model="form.taxesNo" type="text" maxlength="200" clearable></el-input>
            </el-form-item>
            <el-form-item>
                发票内容：购买商品明细
            </el-form-item>
            <el-form-item>
                <el-checkbox v-model="isSave">保存为默认发票信息</el-checkbox>
            </el-form-item>
            <el-form-item>
                <app-button @click.native="submitForm" size="md" color="golden-solid">
                    确认
                </app-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isSave: true,

                form: {
                    invoiceType: '2',
                    invoiceName: '',
                    taxesNo: '',
                    entAddress: '',
                    bankName: '',
                    tel: '',
                    bankNo: '',
                },
                invoiceNameErrorMsg: '',
                taxesNoErrorMsg: '',
                rules: {
                    invoiceName: [{required: true, message: '请输入发票抬头', trigger: 'blur'},],
                    taxesNo: [{required: true, message: '请输入纳税人识别号', trigger: 'blur'},],
                },
            };
        },
        props: [],
        components: {},
        computed: {},
        created() {
            this.getInvoiceListByType();
        },
        activated() {
        },
        mounted() {
        },
        methods: {
            getInvoiceListByType() {
                var invoiceType = this.form.invoiceType;
                this.$api.getInvoiceListByType(invoiceType).then((res) => {
                    if (res) {
                        this.form.invoiceName = res.invoiceName;
                        this.form.taxesNo = res.taxesNo;
                    }
                });
            },
            submitForm() {
                var self = this;
                var _form = this.form;
                this.$refs['form'].validate((valid) => {
                    if (valid) {

                        if (this.isSave) {//保存为默认发票信息
                            this.$api.addInvoice(_form).then((res) => {
                                this.$message({type: 'success', message: '操作成功!'});
                            });
                        }
                        this.$emit('submitForm', _form);
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    @import "../../style/page-common";

    .form-box {
        .el-form {
            margin-top: 0;
        }
    }
</style>